module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAASCAYAAABrXO8xAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAADqADAAQAAAABAAAAEgAAAAAY4EN5AAAA9UlEQVQ4EY2POw5BQRhG76USjYTCBiyAThQKHb3CXQSFHViESit6Kp1KqCSIBQiVSDwiEo/rTIwb5oFJvsz85/9OMY7D8X0/SwZkQxqC/TwUPXIj78f7R1y8G/I9/0c8G0SBkt/kEMujobCF7Q08QEKcBtPzseIquq57UvjHKMTuB3GcJtJIYfrIX1LKH6fMrt40EIojRa4YajpCKijimjmmNw2EYl+R24aajpAy5KrIVdGEhUmaJHTzWagr4p25SeaSH7jLNrkjS7brwiKnycAomdgsyYeaKADLOBl/kZdGUcoRxJZFrlnF1wIxT3pkR2akJHYPd/OXd+gEDhcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_index_icon9.png
// module id = vghM
// module chunks = 1